import React, {useState} from 'react';
import {FormattedMessage} from "react-intl";

const BusinessCalculator = ({toggleLastStep}) => {
    const currentYear = new Date().getFullYear();

    const [selectedYear, setSelectedYear] = useState();

    return (
        <div>
            <div className="ct-step__income-calculator-modal__subtitle">
              <FormattedMessage id="incomeCalculator.type.selfEmployed.sinceWhen" defaultMessage="Vanaf wanneer werk je zelfstandig?"/>
            </div>

            <section className="ct-step-xl-labels">
                <div className="ct-step-xl-labels__container ct-step-xl-labels-low-margin">
                    <button
                        className={(selectedYear === currentYear) ? "selected-xl-label" : null}
                        onClick={() => setSelectedYear(currentYear)}
                    >
                        {currentYear}
                    </button>

                    <button
                        className={(selectedYear === currentYear - 1) ? "selected-xl-label" : null}
                        onClick={() => setSelectedYear(currentYear - 1)}
                    >
                        {currentYear - 1}
                    </button>

                    <button
                        className={(selectedYear === currentYear - 2) ? "selected-xl-label" : null}
                        onClick={() => setSelectedYear(currentYear - 2)}
                    >
                        {currentYear - 2}
                    </button>

                    <button
                        className={(selectedYear === currentYear - 3) ? "selected-xl-label" : null}
                        onClick={() => setSelectedYear(currentYear - 3)}
                    >
                        {currentYear - 3}
                    </button>

                    <button
                        className={(selectedYear === currentYear - 4) ? "selected-xl-label" : null}
                        onClick={() => setSelectedYear(currentYear - 4)}
                    >
                      <FormattedMessage id="incomeCalculator.type.selfEmployed.sinceWhen.before" defaultMessage="Eerder dan "/>
                       {currentYear - 3}
                    </button>
                </div>
            </section>

            {selectedYear && (
                <div className="ct-business-calculator__explanation-block">
                    <div className="ct-step__income-calculator-modal__subtitle ct-info-icon-block">
                        <div className="ct-info-icon">
                            i
                        </div>

                        <div>
                          <FormattedMessage id="incomeCalculator.type.selfEmployed.information.title" defaultMessage="Toelichting"/>
                        </div>
                    </div>

                    <div>
                      <FormattedMessage id="incomeCalculator.type.selfEmployed.information.sameYear" defaultMessage="Je dient minimaal 12 maanden actief te zijn als ondernemer. Uitgangspunt hierbij is de inschrijving bij de Kamer van Koophandel."/>

                      {selectedYear === currentYear ? (
                          <FormattedMessage id="incomeCalculator.type.selfEmployed.information.sameYear" defaultMessage="Je dient minimaal 12 maanden actief te zijn als ondernemer. Uitgangspunt hierbij is de inschrijving bij de Kamer van Koophandel."/>
                        ) : (
                          <FormattedMessage id="incomeCalculator.type.selfEmployed.information.otherYear" defaultMessage="Zorg dat je je aangiften inkomstenbelasting en de jaarcijfers van de afgelopen drie jaar bij de hand hebt."/>
                        )}

                    </div>
                </div>
            )}

            <button
                onClick={toggleLastStep}
                className="ct__button ct-header__afspraak"
            >
              <FormattedMessage id="incomeCalculator.calculateButton" defaultMessage="Volgende"/>
            </button>

        </div>
    );
};

export default BusinessCalculator;
